<template>
    <div class="deal_index_box">
        <!-- 資金管理 -->
        <div class="deal_title">
            <div>資金管理<span>》</span>轉出/轉入記錄</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box"  v-show="detailsTF" v-loading="inquireTF">
            <div class="deal_content_title">轉出/轉入記錄</div>
            <div class="deal_content">
                <div class="center_box">
                    <!-- 轉出/轉入記錄 -->
                    <el-form ref="form" :model="form" label-width="90px">
                        <!-- <el-form-item label="業務類型：">
                            <el-radio v-model="radio" label="1">儲值</el-radio>
                            <el-radio v-model="radio" label="2">提領</el-radio>
                            <el-radio v-model="radio" label="0">帳戶間轉帳</el-radio>
                        </el-form-item> -->
                        <el-form-item label="申請時間：">
                            <el-date-picker
                                v-model="dateValue"
                                type="daterange"
                                align="center"
                                value-format="timestamp"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                            <span class="deal_content_span">查詢期日不可超過31天</span>
                        </el-form-item>
                    </el-form>
                    <!-- 查詢按钮 -->
                    <div class="inquire_button">
                        <el-button type="primary" @click="inquireFun()">查詢</el-button>   
                        <el-input v-model="input" placeholder="請輸入轉入/轉出單號查詢" class="input_box">
                            <el-button slot="append" icon="el-icon-search" @click="inquireFun()"></el-button>
                        </el-input>
                    </div>
                    <!-- 表单 -->
                    <div class="table_download">
                        <span>匯出記錄</span>
                        <span><img src="../../../../assets/img/login/logindeal/icon_xls.png" @click="ExcelFun('exportexcel')" alt=""></span>
                        <span><img src="../../../../assets/img/login/logindeal/icon_txt.png" @click="ExcelFun('exporttxt')" alt=""></span>
                    </div>
                    <div>
                         <!-- 表单头 -->
                            <div class="table_header">
                                <div class="table_date">發起時間</div>
                                <div class="table_merchantorder">轉入/轉出單號</div>
								<div class="table_uid"  v-if="omld==1">uid</div>
                                <div class="table_service">手續費</div>
                                <div class="table_pay_moy">實際到帳</div>
                                <div class="table_over">帳戶餘額</div>
                                <div class="table_account">出款帳戶</div>
                                <div class="table_account2">入款帳戶</div>
                                <div class="table_account_type">業務類型</div>
                                <div class="table_money">金額</div>
                                <div class="table_status">狀態</div>
                                <div class="table_operation">操作</div>
                            </div>
                            <!-- 表单内容 -->
                            <div class="table_maxbox" v-for="(list, index) of pagelist" :key="index" v-show="currentPage == (index+1)">
                                <div class="table_content" v-for="item of list" :key="item.id">
                                    <div class="table_date">{{item.starttime}}</div>
                                    <div class="table_merchantorder">{{item.code}}</div>
									<div class="table_uid" v-if="omld==1">{{item.uid}}</div>
                                    <div class="table_service">{{item.commission}}</div>
                                    <div class="table_pay_moy">{{item.change_money}}</div>
                                    <div class="table_over">{{item.final_money}}</div>
                                    <div class="table_account">{{item.ck}}</div>
                                    <div class="table_account2">{{item.rk}}</div>
                                    <div class="table_account_type">{{item.type}}</div>
                                    <div class="table_money">{{item.money}}</div>
                                    <div class="table_status">{{item.status}}</div>
                                    
                                    <div class="table_operation">
                                        <span @click="detailsFun(item.id, item.time)">
                                            <span>查看</span><i class="el-icon-view"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        <!-- 表单分页列表 -->
                        <div class="table_pagination">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[10, 30, 50]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalNumber"
                                >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <record-details v-show="!detailsTF" @detailsFun="detailsFun()"></record-details>
        <!-- deal_index_box -->
    </div>
</template>

<script>
import axios from 'axios';
import RecordDetails from '../../common/RecordDetails.vue';

export default {
    name: 'LoginDealRecord',
    data() {
        return {
            form:{
            },
            radio: '0',
            input: '',
			omld:this.$store.state.uid,
            // 查询时候加载状态
            inquireTF: false,
            // 訂單詳情切換
            detailsTF: true,
            // 日期
            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            dateValue: '',
            paymentValue: '',
            transactionValue: '',
            end_time: '',
            start_time: '',
            // 表单
            tableData:[],
            totalNumber: 0,
            currentPage: 1,
            pageSize: 10,
            pagelist:[]
        // return
        }
    },
    components: {
        RecordDetails
    },
    methods: {
        handleClick(tab, event) {
            // console.log(tab, event);
        },
       handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.pagelist = this.pagesFun(val);
        },
        handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;
        },
        // FUN-分頁顯示
        pagesFun(number){
            let pages=[]
            this.tableData.forEach((item,index)=>{
                var page=Math.floor(index/number);
                if(!pages[page]){
                    pages[page]=[];
                }
                pages[page].push(item);
            })
            return pages;
        },
        // FUN-訂單詳情
        detailsFun(id, time){
            this.detailsTF = !this.detailsTF;
            axios.get(this.$store.state.axiosRecordDetailsUrl, {
                params: {
                    id: id,
                    time: time
                }
            }).then((res) => {
                // console.log(res.data.message);
                this.$store.commit('changeDetails',res.data.message);
            })
        },
        // FUN-订单查询
        inquireFun(){
            if(this.dateValue != ''){
                this.end_time = this.dateValue[1].toString();
                this.end_time = this.end_time.substring(0, 10);
                this.start_time = this.dateValue[0].toString();
                this.start_time = this.start_time.substring(0, 10);
            }
            this.inquireTF = true;
            axios.get(this.$store.state.axiosRecordUrl, {
                    params: {
                        // type: this.radio,
                        start_time: this.start_time,
                        end_time: this.end_time,
                        code: this.input,
                        uid: this.$store.state.uid
                    }
            }).then((res) => {
                // console.log(res.data);
                this.currentPage = 1;
                this.inquireTF = false;
                if(res.data.message){

                    if(res.data.status){
                        this.tableData = res.data.message;
                        this.totalNumber = res.data.message.length;
                        this.pagelist = this.pagesFun(this.pageSize);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error',
                            duration: 1000
                        });
                    }

                } else {
                    this.$message({
                        showClose: true,
                        message: '沒有數據',
                        type: 'error',
                        duration: 1000
                    });
                }
            })
        },
        // FUN-EXCEL下載
        ExcelFun(hxr){
            var txt_url = '';
            let charset = '';

            if (navigator.language === "zh-TW"){
                charset = "BIG5";
            } else {
                charset = "GBK";
            }

            // 下載：
            txt_url = this.$store.state.axiosRecordUrl
                +'&end_time='+this.end_time
                +'&start_time='+this.start_time
                +'&uid='+this.$store.state.uid
                // +'&type='+this.radio
                +'&code='+this.input
                +'&charset='+charset
                +'&do='+hxr;

            // console.log(txt_url);
            window.location.href = txt_url;
        },
    },
    created(){
        this.inquireTF = true;
        axios.get(this.$store.state.axiosRecordUrl, {
        params:{
            uid: this.$store.state.uid
        }
        }).then(res =>{
            // console.log(res.data);
            this.inquireTF = false;
            if(res.data.message){
                this.tableData = res.data.message;
                this.totalNumber = res.data.message.length;
                this.pagelist = this.pagesFun(10);
            }
        })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .time_box {
        font-size: 17px;
        margin-bottom: 33px;
        letter-spacing: 1px;
    }
    .time_box > span {
        color: #e73262;
        margin: 0 5px;
    }
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 500px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 38px 20px;
        padding-top: 26px;
    }
    .center_box {
        min-width: 900px;
        margin: 10px 65px;
    }
    .deal_content_span {
        margin-left: 23px;
        font-size: 11px;
        color: #e73262;
    }
    .deal_content_tab_first {
        width: 960px;
    }
    .deal_content_tab_first > div {
        margin: 14px 0;
    }
    .money_box span {
        margin: 0 10px;
    }
    .money_input {
        width: 140px;
        /* margin-left: 4px; */
    }
    .money_input01 {
        margin-left: 4px;
    }
    .inquire_button {
        padding: 10px;
    }
    .input_box {
        width: 300px;
        margin-left: 10px;
    }
    /* 表单 */
    .table_download {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 6px 0;
    }
    .table_download_button {
        padding: 6px 10px;
    }
    .table_download span {
        display: inline-block;
        margin: 0 10px;
    }
    .table_download span img {
        cursor: pointer;
    }
    /* 表单头 */
    .table_header {
        height: 36px;
        line-height: 36px;
        background: #f2f2f2;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        text-align: center;
    }
    .table_maxbox >div+div {
        border-top: 1px solid #e7e7e7;
    }
    .table_content {
        padding: 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        text-align: center;
    }
     .table_date {
        box-sizing: border-box;
        width: 9%;
        padding: 0 10px;
    }
    .table_merchantorder {
        box-sizing: border-box;
        word-break: break-all;
        word-wrap: break-word;
        width: 15%;
        padding: 0 10px;
        /* min-width: 160px; */
    }
    .table_service {
        box-sizing: border-box;
        width: 7%;
        padding: 0 10px;
    }
    .table_rate {
        box-sizing: border-box;
        width: 6%;
        padding: 0 10px;
    }
	.table_uid{
		box-sizing: border-box;
		width: 4%;
		padding: 0 10px;
	}
    .table_pay_moy {
        box-sizing: border-box;
        width: 8%;
        padding: 0 10px;
        word-break: break-all;
        word-wrap: break-word;
    }
    .table_over {
        box-sizing: border-box;
        width: 8%;
        padding: 0 10px;
        word-break: break-all;
        word-wrap: break-word;
    }
    .table_account {
        box-sizing: border-box;
        width: 8%;
        padding: 0 10px;
    }
    .table_account2 {
        box-sizing: border-box;
        width: 13%;
        padding: 0 10px;
    }
    .table_account_type {
        box-sizing: border-box;
        width: 8%;
        padding: 0 10px;
    }
    .table_money {
        box-sizing: border-box;
        width: 6%;
        padding: 0 10px;
        word-break: break-all;
        word-wrap: break-word;
    }
    .table_status {
        box-sizing: border-box;
        width: 6%;
        padding: 0 10px;
    }
    .table_operation {
        padding: 0 10px;
    }
    .table_operation > span {
        cursor: pointer;
        margin-right: 10px;
    }
    .table_operation > span > span {
        margin-right: 2px;
        padding-bottom: 2px;
        border-bottom: 1px solid;
    }
/* 分页 */
    .table_pagination {
        display: flex;
        margin: 20px;
        justify-content: flex-end;
    }
    .annotation {
        font-size: 11px;
        color: #777;
    }
    .annotation > p {
        line-height: 17px;
        margin-left: 18px;
    }
    .annotation .annotation_p {
        margin: 0px;
        margin-top: 10px;
    }
    .annotation .annotation_span {
        border-bottom: 1px solid #326ede;
        color: #326ede;
    }
</style>
